/**
 * Tracks everything that currently needs the screen (toasts, dialogs, modals, full-screen overlays) so
 * an app can move a native window out of the way while any of them is up.
 */
export default class OverlaySuppression {

    private static owners: Set<unknown> = new Set();

    /** Called only when suppression starts (first owner) or ends (last owner released). */
    public static onChange: ((suppressed: boolean) => void) | null = null;

    public static acquire(owner: unknown): void {
        if (OverlaySuppression.owners.has(owner)) return;
        OverlaySuppression.owners.add(owner);
        if (OverlaySuppression.owners.size === 1)
            OverlaySuppression.onChange?.(true);
    }

    public static release(owner: unknown): void {
        if (!OverlaySuppression.owners.delete(owner)) return;
        if (OverlaySuppression.owners.size === 0)
            OverlaySuppression.onChange?.(false);
    }

    public static isSuppressed(): boolean {
        return OverlaySuppression.owners.size > 0;
    }
}
